import { http } from '@/http'

/**
 * Carga masiva de vacaciones (wizard validate → batchId → confirm). Reusa el patrón de
 * ContractBulkUploadService (multipart) y el de descargas blob (AttendanceService).
 *
 * Endpoints (baseURL ya incluye /api/v1):
 *   GET  /vacations/bulk-upload/template            (blob xlsx)
 *   POST /vacations/bulk-upload/validate            (multipart) → { batchId, totalRows, validRows, errorRows, rows }
 *   POST /vacations/bulk-upload/confirm/{batchId}   → { created, errors, message }
 */
export default {
  downloadTemplate() {
    return http.get('/vacations/bulk-upload/template', { responseType: 'blob' })
  },
  validate(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/vacations/bulk-upload/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  confirm(batchId) {
    return http.post(`/vacations/bulk-upload/confirm/${batchId}`)
  },
}
